/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from 'graphql-tag';

export const GET_EVENT_DETAIL = gql`
  query Query($input: GetPolicyDetailInput!, $input1: GetTxnListInput) {
    getPolicyDetail(input: $input) {
      policyNumber
      productDefination
      countryToBeInsured
      type
      pdf
      premium
      coverage
      purchasedBy {
        email
        firstName
        lastName
        fullName
        emailVerified
        image
        bannerImg
        address {
          addressLine1
          city
          country
        }
        occupation
        bio
        primaryContactNo
        kyc {
          doc
          name
          status
          type
        }
        nationality
        suspended
        kycSubmitted
      }
      useOfProceeds {
        selected
        value
      }
      termsOfUse {
        selected
        value
      }
      benificiaryDetail {
        address {
          addressLine2
          city
          addressLine1
          country
        }
        email
        firstName
        lastName
        mobileNo
      }
    }
    getTxnList(input: $input1) {
      data {
        action
        payload
        id
        txnOwner {
          email
          firstName
          fullName
          image
          lastName
        }
        performedBy {
          firstName
          lastName
        }
        type
        when
        where
      }
      pageSize
      totalCount
      totalPages
      currentPage
    }
  }
`;
